import gql from 'graphql-tag'

export const QUERY_GET_TAGS = gql`
  query MessageTemplateTags($page: Int, $pageSize: Int, $search: String, $sort: [String], $sortDirection: [SortDirection]) {
    messageTemplateTags(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      page
      records
      tags {
        _id
        color
        name
      }
    }
  }
`

export const QUERY_GET_MESSAGES = gql`
  query MessageTemplates($page: Int, $pageSize: Int, $search: String, $sort: [String], $sortDirection: [SortDirection]) {
    messageTemplates(page: $page, pageSize: $pageSize, search: $search, sort: $sort, sortDirection: $sortDirection) {
      page
      records
      templates {
        _id
        message
        tags {
          _id
          color
          name
        }
        channels
        message_length
        from_campaign
      }
    }
  }
`

export const QUERY_GET_MESSAGE = gql`
  query MessageTemplate($_id: ID!) {
    messageTemplate(_id: $_id) {
      _id
      message
      tags {
        _id
        color
        name
      }
      channels
      message_length
      from_campaign
    }
  }
`

export const MUTATION_DELETE_TAG = gql`
  mutation DeleteTemplateTag($_id: ID!) {
    deleteTemplateTag(_id: $_id)
  }
`

export const MUTATION_DELETE_MESSAGE = gql`
  mutation DeleteTemplateMessage($_id: ID!) {
    deleteTemplateMessage(_id: $_id)
  }
`

export const MUTATION_CREATE_UPDATE_TAG = gql`
  mutation UpsertTemplateTag($data: InputMessageTemplateTag!) {
    upsertTemplateTag(data: $data) {
      _id
      message
    }
  }
`
export const MUTATION_CREATE_UPDATE_MESSAGE = gql`
  mutation UpsertTemplateMessage($data: InputMessageTemplate!) {
    upsertTemplateMessage(data: $data) {
      _id
      message
    }
  }
`
